import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Users, ClipboardList, ShoppingCart, Phone } from 'lucide-react';

const MobileBottomNav = ({ user }) => {
  const location = useLocation();
  
  const navItems = [
    { path: '/', icon: LayoutDashboard, label: 'Ana Sayfa' },
    { path: '/customers', icon: Users, label: 'Müşteriler' },
    { path: '/calls', icon: Phone, label: 'Aramalar' },
    { path: '/sales', icon: ShoppingCart, label: 'Satışlar' },
    { path: '/visits', icon: ClipboardList, label: 'Ziyaretler' },
  ];
  
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50 md:hidden">
      <div className="flex justify-around items-center h-16">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
                isActive 
                  ? 'text-[#193046] bg-blue-50' 
                  : 'text-gray-600 hover:text-[#193046]'
              }`}
            >
              <Icon className={`w-6 h-6 mb-1 ${isActive ? 'stroke-[2.5]' : ''}`} />
              <span className="text-xs font-medium">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default MobileBottomNav;